import { useId, useState } from "react";
import useDataContext from "../../providers/DataProvider/useDataContext";

interface Props {
    onSubmit: (event: React.FormEvent<HTMLFormElement>) => Promise<void>;
}

const ContactForm: React.FC<Props> = ({ onSubmit }) => {
    const { data } = useDataContext();
    const [inputValues, setInputValues] = useState({
        userName: "",
        userEmail: "",
        userMessage: ""
    });
    const isButtonDisabled = inputValues.userEmail.trim() !== "" &&
                             inputValues.userMessage.trim() !== "";

    const userNameID = useId();
    const userEmailID = useId();
    const userMessageID = useId();

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setInputValues(prev => ({
            ...prev,
            [name]: value
        }))
    }

    return (
        <form action="https://formspree.io/f/mwkgalpr"
              method="POST"
              onSubmit={(e) => void onSubmit(e)}
              className="flex flex-col gap-8">
            <div className="flex flex-col">
                <label htmlFor={userNameID}
                       className="text-lg font-semibold">
                    { data.pages.contactPage.contactForm.nameInput.label }
                </label>
                <input id={userNameID} 
                       type="text"
                       name="userName"
                       value={inputValues.userName}
                       onChange={handleInputChange}
                       className="h-12 bg-transparent border-0 py-0
                                  border-b-2 border-b-second-solid 
                                focus:border-b-first-solid focus:ring-0
                                selection:bg-third-solid"/>
            </div>

            <div className="flex flex-col">
                <label htmlFor={userEmailID}
                       className="text-lg font-semibold flex gap-2">
                    <span>
                        { data.pages.contactPage.contactForm.emailInput.label }
                    </span>
                    <span className="font-bold text-first-solid">
                        *
                    </span>
                </label>
                <input id={userEmailID} 
                       type="email" 
                       name="userEmail"
                       value={inputValues.userEmail}
                       onChange={handleInputChange}
                       required={true}
                       className="h-12 bg-transparent border-0 py-0
                                  border-b-2 border-b-second-solid 
                                focus:border-b-first-solid focus:ring-0
                                selection:bg-third-solid"/>
            </div>

            <div className="flex flex-col gap-4">
                <label htmlFor={userMessageID}
                       className="text-lg font-semibold flex gap-2">
                    <span>
                        { data.pages.contactPage.contactForm.messageInput.label }
                    </span>
                    <span className="font-bold text-first-solid">
                        *
                    </span>
                </label>
                <textarea id={userMessageID}
                          name="userMessage"
                          value={inputValues.userMessage}
                          onChange={handleInputChange}
                          rows={12}
                          required={true}
                          className="bg-transparent border-2 border-second-solid 
                                     rounded-xl resize-none 
                                   focus:border-first-solid focus:ring-0">
                </textarea>
            </div>

            <div>
                <button type="submit"
                        className="bg-first-solid w-full text-center rounded-xl
                                     py-4 text-fifth-solid transition-colors duration-200 ease-in-out
                                    hover:bg-second-solid hover:text-first-solid
                                    disabled:bg-first-solid/50 disabled:text-fifth-solid/50"
                        disabled={!isButtonDisabled}>
                    { data.pages.contactPage.contactForm.submitButton }
                </button>
            </div>
        </form>
    )
}

export default ContactForm;
